import { render, staticRenderFns } from "./BGGLink.vue?vue&type=template&id=0873205b&"
import script from "./BGGLink.vue?vue&type=script&lang=js&"
export * from "./BGGLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports